import { FormValues } from './FormValues';

export const defaultFormValues: FormValues = {
  id: '',
  tag_name: '',
  internal_use: undefined,
  description: '',
  color_hex: '',
};
